export default function ({ isDev }) {
  if (!isDev && window.location.protocol !== "https:") {
    window.location.protocol = "https:"
  }
}